export default __webpack_public_path__ + "static/media/whats-branca.b9a77a2c.svg";